// =============================================================================
// Resolves the current AI on Demand scope.
//
// Priority:
//   1. If an AOI is pinned with a geometry → AOI scope
//   2. Otherwise → viewport scope from the map's current bounds
//
// mapRef is needed because the viewport bbox is a property of the map instance,
// not state. We read it lazily at run time.
// =============================================================================

import { useCallback } from 'react';
import { useAoiStore } from '../stores/useAoiStore';

export function useScope(mapRef) {
  const activeAoiId = useAoiStore((s) => s.activeAoiId);
  const aois = useAoiStore((s) => s.aois);

  const activeAoi = (aois ?? []).find((a) => a.id === activeAoiId) ?? null;

  const getScope = useCallback(() => {
    if (activeAoi?.geom) {
      return {
        kind: 'aoi',
        aoi: { id: activeAoi.id, name: activeAoi.name, geom: activeAoi.geom },
      };
    }

    const map = mapRef?.current;
    if (!map) return null;

    const b = map.getBounds();
    const bbox = [b.getWest(), b.getSouth(), b.getEast(), b.getNorth()]
      .map((v) => v.toFixed(6))
      .join(',');

    return { kind: 'viewport', bbox };
  }, [activeAoi, mapRef]);

  return { activeAoi, getScope };
}